import { Link } from "@mui/material";
import * as React from "react";
import { LinkProps } from "./types";
import "./styles.scss";

const classNameBase = "scd-link";

export default function CustomLink(props: LinkProps): React.JSX.Element {
  const { id, href, onClick, children, target, noicon, icon, rel, ...rest } =
    props;

  const iconClass = icon ? (
    <i className={icon} />
  ) : (
    <i className="icon-scd-link-chevron" />
  );

  return (
    <>
      <Link
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            e.currentTarget.click();
          }
        }}
        tabIndex={0}
        id={id}
        className={classNameBase}
        href={href}
        onClick={onClick}
        target={target}
        rel={rel}
        {...rest}
      >
        {!noicon && iconClass}
        {children}
      </Link>
    </>
  );
}
